export { default as TermsAccordion } from './TermsAccordion';
